import React from 'react'
import CloudStorage from '../../CloudStorage/CloudStorage'
import { Tooltip } from "react-tooltip";
import { bidtooltipinfo } from './Tooltips/tooltip';

export default function CommonTooltip({ title, info = "", dontshowtitle = false }) {

    const tooltipId = `tooltip-${Math.random().toString(36).slice(2)}`;

    return (
        <div>
            <h6>
                {!dontshowtitle && <>{title} &nbsp;</>}

                <img
                    data-tooltip-id={tooltipId}
                    data-tooltip-content={info || bidtooltipinfo}
                    src={`${CloudStorage.cloudurl}/Assets/Images/postjob/post-icon.svg`}
                    alt=""
                />
            </h6>

            <Tooltip id={tooltipId} place="top" />
        </div>
    )
}
